if (!customElements.get("sizeguide-toggle")) {
  class SizeguideToggle extends HTMLElement {
    constructor() {
      super();

      this.isInitialized = false;
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      document.dispatchEvent(new CustomEvent("sizeguide:toggle"));
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.addEventListener("click", this.handleClick.bind(this));

      this.isInitialized = true;
    }
  }

  customElements.define("sizeguide-toggle", SizeguideToggle);
}

if (!customElements.get("sizeguide-popup")) {
  class SizeguidePopup extends HTMLElement {
    static OPEN_CLASS = "is-open";
    static ACTIVE_CLASS = "is-active";

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle() {
      this.classList.toggle(SizeguidePopup.OPEN_CLASS);

      document.body.classList.toggle(
        "overflow-hidden",
        this.classList.contains(SizeguidePopup.OPEN_CLASS)
      );
    }

    handleClick(event) {
      const anchor = event.target.closest("a");
      if (!anchor.hasAttribute("js-table")) return;

      const targetTable = this.tables[Number(anchor.getAttribute("js-table"))];
      if (!targetTable) return;

      event.preventDefault();

      this.querySelectorAll(`.${SizeguidePopup.ACTIVE_CLASS}`).forEach(
        (element) => element.classList.remove(SizeguidePopup.ACTIVE_CLASS)
      );

      anchor.classList.add(SizeguidePopup.ACTIVE_CLASS);
      targetTable.classList.add(SizeguidePopup.ACTIVE_CLASS);
    }

    disconnectedCallback() {
      document.removeEventListener("sizeguide:toggle", this.handleToggleRef);
    }

    connectedCallback() {
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }

      if (this.tables) return;

      document.addEventListener("sizeguide:toggle", this.handleToggleRef);

      this.tables = this.querySelectorAll("[js-table-element]");
      this.addEventListener("click", this.handleClick.bind(this));
    }
  }

  customElements.define("sizeguide-popup", SizeguidePopup);
}
